import { render } from "./ModalCenterScreen.html?vue&type=template&id=6c6abfec&scoped=true&ts=true"
import script from "./ModalCenterScreen.vue?vue&type=script&lang=ts"
export * from "./ModalCenterScreen.vue?vue&type=script&lang=ts"

import "./ModalCenterScreen.scss?vue&type=style&index=0&id=6c6abfec&scoped=true&lang=scss"

import exportComponent from "/builds/customer/line/line-web-loyalty/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c6abfec"]])

export default __exports__